import React, { useState, useEffect } from "react";
import { Menu, Grid } from "antd";
// import PrivilegeContext from "../context/privilege";
import { useHistory } from "react-router-dom";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;

const { useBreakpoint } = Grid;

const LeftMenu = ({ handleOnClick ,menuItems}) => {
  const history = useHistory();
  // const { menuItems } = useContext(PrivilegeContext);

  const [itemlist, setitemlist] = useState([]);

  const [current, setCurrent] = useState("mail");
  const onClick = (e) => {
    setCurrent(e.key);
    handleClick();
    const urlGoBack = { pathname: e.key};
    setTimeout(history.push(urlGoBack), 1000);
  };

  const handleClick = (e) => {
    handleOnClick()
  }
  const { md } = useBreakpoint();

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  // console.log('menu=',menulist)

  const items = [
    getItem("Navigation One", "sub1", <MailOutlined />, [
      getItem(
        "Item 1",
        "g1",
        null,
        [getItem("Option 1", "1"), getItem("Option 2", "2")],
        "group"
      ),
      getItem(
        "Item 2",
        "g2",
        null,
        [getItem("Option 3", "3"), getItem("Option 4", "4")],
        "group"
      ),
    ]),
    getItem("Navigation Two", "sub2", <AppstoreOutlined />, [
      getItem("Option 5", "5"),
      getItem("Option 6", "6"),
      getItem("Submenu", "sub3", null, [
        getItem("Option 7", "7"),
        getItem("Option 8", "8"),
      ]),
    ]),
    getItem("Navigation Three", "sub4", <SettingOutlined />, [
      getItem("Option 9", "9"),
      getItem("Option 10", "10"),
      getItem("Option 11", "11"),
      getItem("Option 12", "12"),
    ]),
    getItem("Navigation Four", "sub5", <SettingOutlined />, [
      getItem("Option 9", "9"),
      getItem("Option 10", "10"),
      getItem("Option 11", "11"),
      getItem("Option 12", "12"),
    ]),
  ];
  const items2 = [];

  useEffect(() => {
    if (!menuItems) return;

    menuItems &&
      menuItems.length > 0 &&
      setitemlist(
        menuItems.map((item) => {
          return getItem(
            item.name,
            "main" + item.id,
            item.icon,
            //  item.subMenus

            item.subMenus.map((subitem) => {
              return getItem(subitem.name, subitem.to, subitem.icon1);
            })

            // && item.subMenus.length > 0 ? item.subMenus.map((subitem) => {
            //    return getItem(item.title,item.id,item.iconClassName,[])

            // })
          );
          // return {
          //   value: item._id,
          //   label: item.name,
          // };
        })
      );
  }, [menuItems]);
  // console.log("items=", items);
  // console.log("itemlist=", itemlist);

  return (
    <Menu
 
      onClick={onClick}
      selectedKeys={[current]}
      mode={md ? "horizontal" : "inline"}
      items={itemlist}
      // inlineCollapsed={true}
    />
    // <Menu mode={md ? "horizontal" : "inline"}>
    //   <Menu.Item key="mail">
    //     <a href="">Home</a>
    //   </Menu.Item>
    //   <SubMenu key="sub1" title={<span>Blogs</span>}>
    //     <MenuItemGroup title="Item 1">
    //       <Menu.Item key="setting:1">Option 1</Menu.Item>
    //       <Menu.Item key="setting:2">Option 2</Menu.Item>
    //     </MenuItemGroup>
    //     <MenuItemGroup title="Item 2">
    //       <Menu.Item key="setting:3">Option 3</Menu.Item>
    //       <Menu.Item key="setting:4">Option 4</Menu.Item>
    //     </MenuItemGroup>
    //   </SubMenu>
    //   <Menu.Item key="alipay">
    //     <a href="">Contact Us</a>
    //   </Menu.Item>
    // </Menu>
  );
};

export default LeftMenu;
